import { forEach } from 'jszip';
import { Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AnalysisDataAccessService } from '../servizi/analysis/analysis-data-access.service';
import { FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { ListComponent } from '../library/ebw-list-angular/list.component';
import { GestioneLoginService } from '../servizi/login/gestione-login.service';
import { faMapMarker, faSearch, faEdit, faTrashAlt, faRightLeft } from '@fortawesome/free-solid-svg-icons';
import { ConfigService } from '../servizi/config/config.service';
import { EbwModalService } from '../library/ebw-modals-angular/ebw-modal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnalysisPropertyModalComponent } from '../analysis/analysis-property-modal/analysis-property-modal.component';
import { AnalysisModalEditComponent } from './analysis-modal-edit/analysis-modal-edit.component';
import { AnalysisModalAssociaComponent } from './analysis-modal-associa/analysis-modal-associa.component';
import { ActivatedRoute } from '@angular/router';
import { RouterService } from '../servizi/router.service';
import { EBWModalResult } from '../library/ebw-modals-angular/model/ebw-modal.model';
import { Subscription } from 'rxjs';
import * as FileSaver from "file-saver";

@Component({
  selector: 'app-gestione-analisi-massiva',
  templateUrl: './gestione-analisi-massiva.component.html',
  styleUrls: ['./gestione-analisi-massiva.component.scss']
})

// TODO La funzionalità avrà un permesso specifico che potrà essere fornito solo ad utenti “privilegiati”
export class GestioneAnalisiMassivaComponent implements OnInit, OnDestroy {

  /** Componente lista */
  @ViewChild('listComponent', { static: false }) listComponent: ListComponent;

  /** Icone delle actions della lista */
  icons = {
    faMapMarker: faMapMarker,
    faSearch: faSearch,
    faEdit: faEdit,
    faTrashAlt: faTrashAlt,
    faRightLeft: faRightLeft
  };

  ready = false;
  filterForm: FormGroup;

  token: string;

  listType = 'analysis_user_group'; // values: analysis_user_group || no_pagination (per visualizzazione marker)
  listChangedTrigger = 0;
  listParamsFilters = [];
  rowsPerPageOptions = [10,25,50,100];

  // API x tutte le analisi presenti
  restApiPath = this.configService.getConfigListaAnalisi().gestione_massiva.analysis.url;
  listFields = this.configService.getConfigListaAnalisi().gestione_massiva.analysis.fields;

  // Analisi Checkate
  checkedList = [];

  // Bottone Seleziona/Deseleziona tutto
  selectAllBtn = true;

  // Risultati restituiti dalla lista e visualizzati
  listResults = [];

  // Dati paginazione per riposizionarsi dopo il Posizionamento sulla mappa
  pagination;

  // Subscriptions
  subs: Subscription[] = [];

  constructor(
    private analysisDataAccessService: AnalysisDataAccessService,
    private gestioneLoginService: GestioneLoginService,
    private configService: ConfigService,
    private ebwModalService: EbwModalService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private routerSrv: RouterService
  ) { }

  ngOnInit(): void {

    // Ripulisco dopo il posizionamento
    this.checkedList = [];

    // Recupero il token associato al'utente loggato
    this.token = this.gestioneLoginService.getToken();

    this.initializeForm(); 

    this.subs.push(
      this.route.data.subscribe((data: any) => {
  
        if(!!data && !!data.formData){
          this.setFormData(data.formData);
        }
  
        if(!!data && !!data.checkedList){
          this.checkedList = data.checkedList;
         // this.triggerRowCheck();
        }
      })
    )
  }

  ngOnDestroy(){
    this.checkedList = [];
    this.subs.forEach(sub => {
      sub.unsubscribe();
    })
  }

  onListDOMChanged(evt){
    this.triggerRowCheck();
  }
 
  initializeForm(){
    this.filterForm = new FormGroup({
      nome_sito: new FormControl(''),
      piano_lavori: new FormControl(''),
      anno_piano_lavori: new FormControl(''),
      sr: new FormControl('')
    }, [this.atLeastOneValue]);

    this.ready = true;
  }

  // Prepopolamento campi quando torno dal posizionamento
  setFormData(form: any){
    this.filterForm.setValue(form);
    this.onSubmit();
  }

  // Prepopolamento paginazione quando torno dal posizionamento
  setPagination(pagination: any){
    this.listComponent.setPagination(pagination.reqPage, pagination.rowsPerPage);
  }

  public atLeastOneValue(form: FormGroup): ValidationErrors {
    return Object.keys(form.value).some(key => (!!form.value[key] || form.value[key] === 0)) ? 
    null : { atLeastOneRequired: 'Almeno un campo deve essere valorizzato' };
  }
  
  // Applica Filtri
  onSubmit() {

    // Ad ogni filtraggio ripulisco altrimenti l'array delle checkate rimane sporco
    this.checkedList = [];

    // Aggiornamento Filtri per API Elenco da richiamare sia per la lista che senza paginazione
    this.listParamsFilters = [];

    // NOTE: Devono essere visibili tutte le analisi di tutti gli utenti e gruppi quindi il filtro su utente e gruppo qui non ci va

    // "eq || ne || like || in || in_string || gt || mt || between": "todo"
    if (!!this.filterForm.value.nome_sito && this.filterForm.value.nome_sito.trim() != '') {
      this.listParamsFilters.push(
        {
          field: "nome_sito",
          like: this.filterForm.value.nome_sito
        },
      );
    }

    if (!!this.filterForm.value.piano_lavori && this.filterForm.value.piano_lavori.trim() != '') {
      this.listParamsFilters.push(
        {
          field: "piano_lavori",
          like: this.filterForm.value.piano_lavori
        },
      );
    }

    if (!!this.filterForm.value.anno_piano_lavori && this.filterForm.value.anno_piano_lavori.trim() != '') {
      this.listParamsFilters.push(
        {
          field: "anno_piano_lavori",
          like: this.filterForm.value.anno_piano_lavori
        },
      );
    }

    if (!!this.filterForm.value.sr && this.filterForm.value.sr.trim() != '') {
      this.listParamsFilters.push(
        {
          field: "sr",
          like: this.filterForm.value.sr
        },
      );
    }

    // Trigger aggiornamento parametri iniziali lista
    setTimeout(() => this.listChangedTrigger = this.listChangedTrigger + 1, 0);
  }


  /** Reset Form Filtri e Lista */
  onReset(){
    this.filterForm.reset();
    this.listParamsFilters = [];
    this.checkedList = [];

    setTimeout(() => this.listChangedTrigger = this.listChangedTrigger + 1, 0);
  }
  
  // Caricamento lista avvenuto
  onListLoaded(evt){}

  // Valori lista caricati
  onListValues(listResults){

    this.listResults = listResults;

    if(!!this.checkedList && this.checkedList.length > 0){
      setTimeout(() => { this.triggerRowCheck(); }, 0);
    }
  }

  /** Checkata Checkbox della singola analisi */
  onCheckboxClicked(evt){
    // Check
    if(evt.isChecked){
      this.checkedList.push(evt.record.id)
    } 
    // Uncheck
    else {
      let index = this.checkedList.indexOf(evt.record.id);
      if(index !== -1){
        this.checkedList.splice(
          index,
          1
        );
      }
    } 
  }

  
  private _onCallView(analysisId: string) {
    this.subs.push(
      this.analysisDataAccessService.getAnalysis(analysisId).subscribe({
        next: (res) => {
          
          if(res && res.error !== 0 ){
            this.ebwModalService.openErrorModal({
              title: "Errore",
              content: res.errorDescription,
            })
            return;
          }
  
          let analysisModal = this.modalService.open(AnalysisPropertyModalComponent, { ariaLabelledBy: 'modal-basic-title', size: 'l' });
          const tempData = res.data[0];
          tempData["name"]= res.data[0].nome_sito;
          
          analysisModal.componentInstance.data = tempData;
        },
        error: (error) => {
          this.ebwModalService.openErrorModal({
            title: "Errore",
            content: "Errore durante recupero dati analisi",
          })
        }
      })
    );
  }
  
  /** Bottone Seleziona/Deseleziona tutto */
  onSelectAll(){

    // Select All
    if(this.selectAllBtn){
      // Usare l'API getElenco della ebw-list senza paginazione per tirare fuori tutti gli id delle analisi filtrate e non
      // (ebw-list normale tira fuori i dati paginati per visualizzarli nella lista, per il select all invece devo fuori tutto)
  
      let params = {
        select: 'no_pagination',
        dbFields: 'analysis.id AS id',
        dbFieldsForGroupBy: "analysis.id",
        filterBy: this.listParamsFilters,
        orderBy: [{ "field": "analysis.id", "order": "desc" }],
      };
  
      this.subs.push(
        this.analysisDataAccessService.analysisGetElenco(params).subscribe({
          next: (res) => {
            this.checkedList = res.results.map(el => el.id);
            // console.log("this.checkedList --->", this.checkedList);
            this.triggerRowCheck();
          },
        })
      );
    } 
    // Deselect All
    else {
      this.checkedList = [];

      // Decheckare tutto
      this.triggerRowCheck();
    }

    this.selectAllBtn = !this.selectAllBtn;
    
  }

  /** Checkare/Decheckare visivamente tutte le checkbox della pagina corrispondenti alle analisi il cui id è presente in this.checkedList */
  triggerRowCheck(evt?:any){
    let headerCheckbox = document.getElementById(this.listFields[0].header) as HTMLInputElement | null;
    
    this.listResults.forEach(el => {
      let checkbox = document.getElementById(
        el.id,
      ) as HTMLInputElement | null;

      if(!!checkbox){
        // Check
        if(this.checkedList.includes(el.id)){
          headerCheckbox.checked = true;
          checkbox.checked = true;
        } 
        // Uncheck
        else{
          headerCheckbox.checked = false;
          checkbox.checked = false;
        }
      }
    });

    
    
  }

  // Click checkbox nell'header
  onCheckboxHeaderClicked(evt) {
    // NOTE: Triggera onCheckboxClicked per ogni checkbox della pagina
  }

  public onCallMassiveEdit() {
    this._openEditModal(this.checkedList);
  }

  public onCallMassiveDelete() {
    this._openDeleteConfirmModal(this.checkedList);
  }

  onCallAssocia(analysisIds: string[]) {
    let analysisAssociaModal = this.modalService.open(AnalysisModalAssociaComponent, { ariaLabelledBy: 'modal-basic-title', size: 'l',centered: true });
    analysisAssociaModal.componentInstance.analysisIds = analysisIds;

    analysisAssociaModal.result.then((result) =>  {
      if(result && result.isEdited){
        this.checkedList = [];

        setTimeout(() => {
          this.listChangedTrigger = this.listChangedTrigger + 1
        }, 0);
      }
    });
  }


  // Pressione bottone Action
  onAction(evt: { action: string, rowId: string}) {
    switch (evt.action) {
      case 'callView':
        this._onCallView(evt.rowId);
        break;
      case 'callPosizionamento':
        this._onCallPosizionamento(evt.rowId);
        break;
      case 'callAssocia':
        this._onCallAssocia([evt.rowId]);
        break;
      case 'callEdit':
        this._onCallEdit(evt.rowId);
        break;
      case 'callDelete':
        this._onCallDelete(evt.rowId);
        break;

      default:
        console.log("onAction ---> ", evt);
        break;
    }
  }

  private _onCallPosizionamento(analysisId: string){

    let analysis = this.listResults.filter(el => el.id == analysisId)

    console.log(analysis)

    // Se per errore ci sono duplicati prendo la prima
    if(!!analysis && !!analysis[0].area){
      const data = {
        backPath:'gestione-analisi-massiva',
        mapAction: 'fit', //  Per Centrare la mappa sulla geometria
        pagination: this.listComponent.bodyParams.pagination,
        formData: this.filterForm.value,
        checkedList: this.checkedList,
        geom: analysis[0].area, // La mappa farà il fit sulla geometria dell'analisi
     };

     // Chiusura pagina ricerca apertura Mappa
     this.routerSrv.navigateToChild('mappa', data);
    }
  }

  private _onCallAssocia(analysisIds: string[]) {
    this.onCallAssocia(analysisIds);
  }

  private _onCallEdit(analysisId: string) {
    this._openEditModal([analysisId]);
  }

  private _onCallDelete(analysisId: string) {
    this._openDeleteConfirmModal([analysisId])
  }

  private _openEditModal(ids: string[]) {
    let analysisEditModal = this.modalService.open(AnalysisModalEditComponent, { ariaLabelledBy: 'modal-basic-title', size: 'l', centered: true });
    analysisEditModal.componentInstance.ids = ids;
    analysisEditModal.result.then((result) =>  {
      if(result && result.isEdited){
        this.checkedList = [];

        setTimeout(() => {
          this.listChangedTrigger = this.listChangedTrigger + 1
        }, 0);
      }
    });
  }

  private _openDeleteConfirmModal(ids: string[]) {

    let content;
    let title;

    if(ids.length > 1){
      title ="Eliminazione Analisi Massiva";
      content = "L'operazione comporterà l'eliminazione massiva delle analisi selezionate. Continuare?";
    } else {
      title ="Eliminazione Analisi";
      content = "L'operazione comporterà l'eliminazione dell'analisi selezionata. Continuare?";
    }

    this.ebwModalService.openConfirmModal({
      title: title,
      content: content
    }).result.then(res => {
      if (res == EBWModalResult.Confirm) {
        this._deleteAnalyses(ids);
      }
    })

  }

  private _deleteAnalyses(ids: string[]) {

    this.subs.push(
      this.analysisDataAccessService.removeAnalyses({ ids })
      .subscribe({
        next: (res) => {

          if (!res || res.error !== 0) {
            this.ebwModalService.openErrorModal({
              title: "Errore",
              content: "Errore cancellazione dati: " + res.errorDescription
            });
          }

          this.ebwModalService.openSuccessModal({
            title: "Successo",
            content: "Analisi cancellate"
          });

          this.checkedList = [];

          setTimeout(() => {
            this.listChangedTrigger = this.listChangedTrigger + 1
          }, 0);

        },
        error: (error) => {
          this.ebwModalService.openErrorModal({
            title: "Errore",
            content: "Errore cancellazione dati"
          });
        }
      })
    );
  }

  onCallExport() {
    let params = {
      select: 'no_pagination',
      dbFields: `
        analysis.id AS id, 
        analysis.nome_sito, 
        analysis.piano_lavori, 
        analysis.anno_piano_lavori, 
        analysis.colore, analysis.sr, 
        analysis.codice_cliente_1,
        analysis.codice_cliente_2,
        analysis.codice_cliente_3,
        analysis.regione,
        analysis.provincia,
        analysis.comune,
        analysis.altezza_centro_elettrico_m,
        analysis.raggio_area_di_ricerca_m
        `,
      dbFieldsForGroupBy: "analysis.id",
      filterBy: this.listParamsFilters,
      orderBy: [{ "field": "analysis.id", "order": "desc" }],
    };

    this.analysisDataAccessService.exportCsv(params).subscribe({
      next: (data) => {
        const downloadURL = window.URL.createObjectURL(data);
        FileSaver.saveAs(downloadURL, `analisi_${new Date().toISOString()}.csv`);
      },
      error: (error) => {
        this.ebwModalService.openErrorModal({
          title: "Errore",
          content: "Errore preparazione export"
        });
      },
    });
  }
}


